import * as React from 'react';

import LoadingSpinnerSimple from './LoadingSpinnerSimple';
export interface SnackbarProps extends React.HTMLProps<HTMLDivElement> {
	containerWidth: number;
}

export const Snackbar = React.forwardRef<HTMLDivElement, SnackbarProps>(
	({ containerWidth, children }, ref) => {
		return (
			<div
				ref={ref}
				data-testid="chat-snackbar"
				className="chat-snackbar absolute bottom-0 left-0 right-0 z-20 p-2"
				style={{ width: containerWidth > 0 ? `${containerWidth}px` : '96%' }}
			>
				<div className="bg-gray-90 flex px-4 py-3 text-white rounded">
					<div>
						<LoadingSpinnerSimple size={20} />
					</div>
					<div className="text-caption pl-3 text-white">{children}</div>
				</div>
			</div>
		);
	}
);

export default Snackbar;
